import { PDFDocument } from "pdf-lib"
import { useCallback, useState } from "react"

interface ReorderOptions {
  pageOrder: number[]
}

export function usePdfReorder() {
  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const reorderPdf = useCallback(
    async (file: File, options: ReorderOptions) => {
      setProcessing(true)
      setError(null)

      try {
        const arrayBuffer = await file.arrayBuffer()
        const sourcePdf = await PDFDocument.load(arrayBuffer)
        const newPdf = await PDFDocument.create()

        const indices = options.pageOrder.map((p) => p - 1)
        const pages = await newPdf.copyPages(sourcePdf, indices)
        pages.forEach((page) => newPdf.addPage(page))

        const pdfBytes = await newPdf.save()
        return new Blob([pdfBytes as BlobPart], { type: "application/pdf" })
      } catch (err) {
        const message =
          err instanceof Error ? err.message : "Failed to reorder PDF"
        setError(message)
        throw err
      } finally {
        setProcessing(false)
      }
    },
    [],
  )

  return { reorderPdf, processing, error }
}
